import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import type { IntegratorSubappKey } from "@hub-modules";

import { readLastApp, rememberLastApp } from "@/components/AppSwitcher";
import { resolveCoHomedLayoutApp } from "@/lib/coHomedLayoutApp";
import { useIntegratorMe } from "@/lib/me-query";
import { appsVisibleToUser } from "@/lib/subapp-access";

/**
 * Layout chrome module for the current URL. Every `Layout` uses this so co-homed
 * `NavItem.coHomeAppKeys` (and the same `to` listed on multiple modules) keep the
 * current module when the operator is already in one of those homes.
 */
export function useCoHomedLayoutApp(routeApp: IntegratorSubappKey): IntegratorSubappKey {
  const { pathname } = useLocation();
  const { data: me } = useIntegratorMe();
  const accessibleKeys = me?.user
    ? new Set(appsVisibleToUser(me).map((row) => row.key))
    : null;
  const app = resolveCoHomedLayoutApp({
    pathname,
    routeApp,
    lastApp: readLastApp(),
    accessibleKeys,
  });

  useEffect(() => {
    if (!me?.user) {
      return;
    }
    rememberLastApp(app);
  }, [app, me?.user]);

  return app;
}
